import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Client, Id } from '../../domain/data';
import { GetParticipantsUseCase } from '../../../core';

export const existsInContract = (
    clientId: Id,
    field: string,
    otherValue: string,
    getParticipantsUseCase: GetParticipantsUseCase
): AsyncValidatorFn => {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        const v: string = control.value;

        return getParticipantsUseCase.bind({ isFull: false }).pipe(
            debounceTime(400),
            distinctUntilChanged(),
            map((transaction) => {
                if (transaction.isSuccess) {
                    const participants = transaction.data as Client[];
                    let repeat = otherValue && otherValue === v;

                    if (!repeat && field) {
                        participants.map((participant) => {
                            if (participant[field] === v && String(participant.id) !== String(clientId)) {
                                repeat = true;
                            }
                        });
                    }

                    return repeat ? { existsInContract: true } : null;
                } else {
                    return null;
                }
            })
        );
    };
};
